import { PageHeader } from "@di-devs/base-components";
import type React from "react";
import type { FC, ReactNode } from "react";
import { useAudienceContext } from "../providers/AudienceContext";

export interface AudienceTitleProps {
	children: ReactNode;
	extra?: ReactNode;
	subtitle?: ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

const AudienceTitle: FC<AudienceTitleProps> = ({
	children,
	extra,
	subtitle,
	className = "",
	style,
}) => {
	const { publicSettings } = useAudienceContext();

	// Map the audience PublicSettings to PageHeader's expected format
	const mappedPublicSettings = publicSettings
		? {
				PRIMARY_COLOR: publicSettings.PRIMARY_COLOR?.valueString
					? {
							valueString: publicSettings.PRIMARY_COLOR.valueString,
						}
					: undefined,
				PRIMARY_LIGHT_COLOR: publicSettings.PRIMARY_LIGHT_COLOR?.valueString
					? {
							valueString: publicSettings.PRIMARY_LIGHT_COLOR.valueString,
						}
					: undefined,
			}
		: undefined;

	return (
		<div className={className} style={style}>
			<PageHeader
				title={children}
				subtitle={subtitle}
				actions={extra}
				publicSettings={mappedPublicSettings}
			/>
		</div>
	);
};

export default AudienceTitle;
